import {
  VERIFY_EMAIL_REQUEST,
  VERIFY_EMAIL_SUCCESS,
  VERIFY_EMAIL_FAILURE,
  RESEND_VERIFICATION_REQUEST,
  RESEND_VERIFICATION_SUCCESS,
  RESEND_VERIFICATION_FAILURE
} from '../../../constants/profile/emailVerification';

interface EmailVerificationState {
  loading: boolean;
  verifying: boolean;
  resending: boolean;
  success: boolean;
  error: string | null;
}

const INIT_STATE: EmailVerificationState = {
  loading: false,
  verifying: false,
  resending: false,
  success: false,
  error: null
};

export default (state = INIT_STATE, action: any): EmailVerificationState => {
  switch (action.type) {
    case VERIFY_EMAIL_REQUEST:
      return {
        ...state,
        verifying: true,
        loading: true,
        success: false,
        error: null
      };

    case VERIFY_EMAIL_SUCCESS:
      return {
        ...state,
        verifying: false,
        loading: false,
        success: true,
        error: null
      };

    case VERIFY_EMAIL_FAILURE:
      return {
        ...state,
        verifying: false,
        loading: false,
        success: false,
        error: action.payload
      };

    case RESEND_VERIFICATION_REQUEST:
      return {
        ...state,
        resending: true,
        loading: true,
        success: false,
        error: null
      };

    case RESEND_VERIFICATION_SUCCESS:
      return {
        ...state,
        resending: false,
        loading: false,
        success: true,
        error: null
      };

    case RESEND_VERIFICATION_FAILURE:
      return {
        ...state,
        resending: false,
        loading: false,
        success: false,
        error: action.payload
      };

    default:
      return state;
  }
};